import {PaymentMethodsService} from "../../../../services";
import {errorMsg, successMsg} from "../../../../utils/MessageUtils";
import {createSlice, Dispatch} from "@reduxjs/toolkit";
import {fetchAllPaymentMethods} from "./paymentmethods-list.slice";


interface ActivatePaymentMethodStateParams {
    id: string;
    onSuccess?: Function;
    onError?: Function;
}

export const activatePaymentMethod = (params: ActivatePaymentMethodStateParams) => async (dispatch: Dispatch) => {
    try {
        dispatch(setLoading(true));
        const response = await PaymentMethodsService.activatePaymentMethod(params.id);
        if (response.status >= 200 && response.status < 300) {
            dispatch(setSuccess(true));
            dispatch(successMsg(localStorage.getItem('i18nextLng') === 'en' ? 'Payment Method activated successfully!' : 'Metoda e pageses u aktivizua me sukses!'));
            if (params.onSuccess) params.onSuccess();
            dispatch(setError(""));
            // @ts-ignore
            dispatch(fetchAllPaymentMethods());
        }
        dispatch(setLoading(false));
    } catch (err) {
        dispatch(setLoading(false));
        dispatch(errorMsg(err.data.message));
        if (params.onError) params.onError();
        dispatch(setError(err.data.message));
    }
};


interface CreatePaymentMethodSlice {
    success: boolean;
    error: string;
    loading: boolean;
}

const initialState: CreatePaymentMethodSlice = {
    error: '',
    success: false,
    loading: false
}

const stateSlice = createSlice({
    name: 'paymentMethod/activate-paymentMethod',
    initialState,
    reducers: {
        setLoading: (state, action) => {
            state.loading = action.payload
        },
        setSuccess: (state, action) => {
            state.success = action.payload
        },
        setError: (state, action) => {
            state.error = action.payload
        }
    }
})

export const {setLoading, setSuccess, setError} = stateSlice.actions;

export default stateSlice.reducer;